import React from 'react'
import stylesC from '../../styles/common.module.css';
import { IMAGEPATH } from '../../constants/imagePath';
import { Link } from "react-router-dom";
import { KR } from '../../constants/localizations';

export default function Footer() {
    return (
        <footer className={` ${stylesC.footerWrap}`}>
            <div className={` ${stylesC.section} ${stylesC.footerT}`}>
                <div className={` ${stylesC.logo}`}>
                    <Link to="/">
                        <img src={IMAGEPATH.logoL} alt="ar247_logo" loading="lazy" />
                    </Link>
                    <div>
                        69, Seongnam-daero, Bundang-gu, Seongnam-si, Gyeonggi-do <br />
                        Rodland EZ Tower, Suite 407
                    </div>
                    <div className={stylesC.contactM}>
                        <span>
                            {KR.label_footer_email_text}
                        </span>
                        <span>
                            {KR.label_footer_fax_num}
                        </span>
                    </div>
                </div>
                {/* only mobile */}
                {/* only pc (contact, divide,footerB)*/}
                <div className={`${stylesC.contact}`}>
                    <div className={stylesC.contactBox}>
                        <div>
                            {KR.label_footer_contact_text}
                        </div>
                        <div>
                            <span>
                                {KR.label_footer_email}
                            </span>
                            <span>{KR.label_footer_email_text}</span>
                        </div>
                        <div>
                            <span>
                                {KR.label_footer_fax}
                            </span>
                            <span>{KR.label_footer_fax_num}</span>
                        </div>
                    </div>
                    <div className={stylesC.contactBox}>
                        <div>
                            {KR.label_footer_location}
                        </div>
                        <div>
                            경기도 성남시 분당구 성남대로 69
                        </div>
                        <div>
                            로드랜드EZ타워 407호
                        </div>
                    </div>
                    <div className={stylesC.contactBox}>
                        <div>
                            {KR.label_footer_social}
                        </div>
                        <div>
                            <a href="https://www.youtube.com/@ar247autonomousrobot">youtube</a>
                        </div>
                    </div>
                </div>
            </div>
            <span className={stylesC.divide}></span>
            <div className={`${stylesC.footerB}`}>
                <div className={``}>
                    <Link to="/">{KR.label_footer_policy}</Link>
                    <Link to="/">{KR.label_footer_service}</Link>
                </div>
                <div className={``}>
                    {KR.label_footer_copyright}
                </div>
            </div>
        </footer>
    );
}
